<div class="vox-card sms-balance-section mb-4 mb-sm-0">
  <div *ngIf="!smsBalanceLoading && bundle">
    <div class="title mb-2">
      <span class="vox-heading-3" translate>companies.sms.balance.title</span>
      <button *ngIf="smsBalanceError" (click)="getBalance()" container="body" placement="left"
        [ngbTooltip]="'companies.sms.balance.re-try' | translate" class="vox-btn vox-btn-icon"> <i
          class="icon-small-update"></i> </button>
    </div>
    <div class="title">
      <span class="vox-heading-6" translate>companies.sms.balance.month</span>
      <span class="vox-heading-6">{{bundle?.monthly?.balance}}/{{bundle?.monthly?.total}}</span>
    </div>
    <div class="vox-progress progress">
      <div class="vox-progress__bar vox-progress__bar_royal-blue progress-bar" role="progressbar"
        [style.width.%]="bundle?.monthly?.balance / bundle?.monthly?.total * 100">
      </div>
    </div>
    <div class="title mt-3">
      <span class="vox-heading-6" translate>companies.sms.balance.one-time</span>
      <span class="vox-heading-6">{{bundle?.one_time?.balance}}</span>
    </div>
    <div class="title mt-2">
      <span class="vox-heading-6" translate>companies.sms.balance.total</span>
      <span class="vox-heading-6">{{bundle?.total}}</span>
    </div>
  </div>
  <div *ngIf="smsBalanceLoading">
    <ngx-skeleton-loader [theme]="{ 'height': '32px','width': '140px', 'margin-bottom': '10px' }"></ngx-skeleton-loader><br>
    <div class="title">
      <ngx-skeleton-loader [theme]="{ 'height': '12px', 'width': '140px', 'margin-bottom': '0px'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{ 'height': '12px', 'width': '60px', 'margin-bottom': '0px'}"></ngx-skeleton-loader>
    </div>
    <ngx-skeleton-loader [theme]="{ 'height': '12px'}"></ngx-skeleton-loader>
    <div class="title">
      <ngx-skeleton-loader [theme]="{ 'height': '8px', 'width': '140px' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{ 'height': '8px', 'width': '60px' }"></ngx-skeleton-loader>
    </div>
    <div class="title">
      <ngx-skeleton-loader [theme]="{ 'height': '8px', 'width': '140px' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{ 'height': '8px', 'width': '60px' }"></ngx-skeleton-loader>
    </div>
  </div>
</div>